import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import '../styles/Page4.css';

export function Page4() {
  return (
    <div className="App">
      <Box className="page-wrapper, prevent-overflow" sx={{ flexGrow: 1 }} >

        <Grid container spacing={0}>

          <Grid size={{ xs: 12, md: 12 }} className="image-container">
            <fieldset className="functions-grid">
              <legend className='functions-title'>Functions</legend>
              <div className='responsive-image4' >
                <img src="/img/img4.png" alt="Resumen" className='image4' />
              </div>
            </fieldset>
          </Grid>

          <Grid  size={12} sx={{ borderLeft: "solid #A2D7F9 5px"}} className="grid-item">
            <img src="/img/img5.png" alt="Tabla" className="responsive-image" />
          </Grid>

          <Grid size={12} sx={{ borderRight: "solid #A2D7F9 5px", borderBottom: "solid #A2D7F9 5px" }} className="grid-item">
            <img src="/img/img6.png" alt="Mapa" className="responsive-image" />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

